import { render, staticRenderFns } from "./OverlayCustomContent.vue?vue&type=template&id=0234837e&"
import script from "./OverlayCustomContent.vue?vue&type=script&lang=js&"
export * from "./OverlayCustomContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports